<template>
    <div class="switch-toggle-wrapper" :class="config.styleClass">
        <label :for="config.id">{{ label }}</label>

        <button
            role="switch"
            type="button"
            tabindex="0"
            :id="config.id"
            :class="toggleClass"
            :aria-checked="on ? 'true' : 'false'"
            v-on:keyup.tab="tabFocus = true"
            @blur="tabFocus = false"
            @click="onToggle"></button>
    </div>
</template>

<script>
    import { ButtonState, ToggleUIConfig } from 'models/ButtonConfig';

    export default {
        props: {
            config: {
                type: Object,
                required: true,
                styleClass: '',
            },
        },

        data: function () {
            return {
                on: this.config.value,
                tabFocus: false,
            };
        },

        computed: {
            label() {
                let { displayTexts } = this.config;

                return this.on ? displayTexts[ButtonState.On] : displayTexts[ButtonState.Off];
            },

            toggleClass() {
                let result = {
                    'switch-toggle': true,
                    'switch-toggle--on': this.on,
                    focus: this.tabFocus,
                };

                if (this.config.qaClass) {
                    result[this.config.qaClass] = true;
                }

                return result;
            },
        },

        methods: {
            onToggle() {
                this.on = !this.on;
                this.$emit('toggle', this.on);
            },
        },
        watch: {
            'config.value': function (n, o) {
                this.on = n;
            },
        },
    };
</script>
